import { defineTour } from '@lopettia/simul';

/**
 * Agency owner — cross-tenant portfolio. Mirrors
 * docs/manuals/12-agency-owner.md.
 */
export const agencyOwnerTour = defineTour({
  name: 'Agency portfolio overview',
  description:
    'The cross-tenant portfolio view an agency owner uses to track every '
    + 'client engagement they manage on Kairos.',
  steps: [
    {
      id: 'ao-portfolio',
      kind: 'info',
      target: '[data-tour-id="agency-portfolio-grid"]',
      prelude: { goto: '/agency/portfolio' },
      message:
        '**Agency portfolio.** Every client tenant rendered as a tile with '
        + 'health, pipeline, and recent activity.',
      advanceOn: 'manual',
      spotlight: true,
    },
  ],
});

export default agencyOwnerTour;
